/* @flow */
/**
 * Contains Air Freight report request helpers for default field collection, saved-search criteria
 * normalization, and division-code handling.
 */
import airFreightReportHeader, { airFreightReportHiddenHeader } from '../../constants/airFreightReportHeader';
import { removeAFDivision } from '../../helpers/envServer';

/**
 * Appends default Air Freight visible, secondary, additional, and hidden request fields to the
 * provided field list.
 */
export const getFieldsList = (airFreightSecondaryFields: Object) => {
  airFreightReportHeader
    .filter((header) => header.default)
    .forEach((header) => {
      airFreightSecondaryFields.push(header.primary);
      if (header.secondary) {
        airFreightSecondaryFields.push(header.secondary);
      }
      // Composite columns need their backing fields included in API requests.
      if (header.additionalFields) {
        airFreightSecondaryFields.push(...header.additionalFields);
      }
      if (header.includeInRequest) {
        airFreightSecondaryFields.push(header.primary);
      }
    });
  // to add dpomAirFreight.isLocked in fields with and without overide eligible check
  // Hidden request-only fields keep row actions and eligibility checks working.
  airFreightReportHiddenHeader.forEach((headerRow: Object) => {
    if (headerRow.includeInRequest) {
      airFreightSecondaryFields.push(headerRow.primary);
    }
  });
};

/**
 * Ensures saved Air Freight searches include the dpomAirFreight IS_DEFINED criterion needed by
 * newer searches.
 */
export const searchNewFieldOnSavedSearch = (requestData: Object) => {
  if (Array.isArray(requestData)
    // Older saved searches may not yet contain the Air Freight existence criterion.
    && !requestData.map((field) => field.fieldName).includes('dpomAirFreight')
  ) {
    requestData.push(
      {
        fieldName: 'dpomAirFreight',
        function: 'IS_DEFINED'
      }
    );
  }

  return requestData;
};

/**
 * Applies the Air Freight division-code rule by replacing existing division 20 criteria with a
 * single division 20 filter.
 */
export function setDivisionCode20(searchCritera: Object) {
  // Feature flag keeps existing division criteria when division removal is disabled.
  if (!removeAFDivision) {
    return searchCritera;
  }
  const filteredSearchCritera = searchCritera.filter((searchOption) => (
    searchOption.fieldName !== 'poLine.divisionCode' && ![20].includes(searchOption.fieldValue)
  ));
  filteredSearchCritera.push({
    fieldName: 'poLine.divisionCode',
    operator: '=',
    fieldValue: ['20']
  });
  return filteredSearchCritera;
}
